import TalentFirstStep from "./TalentFirstStep.vue"

export default function install(Vue) {
  Vue.component(TalentFirstStep.name, TalentFirstStep)
}
